<div adaptToolbarContent>
    <span class="dx-datagrid-export-button">
        <button adaptButtonIcon="dx-icon dx-icon-xlsxfile"
                adaptTooltip="Export all data"
                (click)="exportAllData()"></button>
    </span>
    <button adaptButtonIcon="dx-icon dx-icon-column-chooser"
            adaptTooltip="Column chooser"
            (click)="showColumnChooser()"></button>
    <button adaptButtonIcon="dx-icon dx-icon-revert"
            adaptTooltip="Reset columns"
            (click)="resetColumns()"></button>
</div>

<dx-data-grid [columnAutoWidth]="true"
              [allowColumnResizing]="true"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              [stateStoring]="dxGridWrapperHelper.stateStoringOptions"
              [dataSource]="data"
              (onInitialized)="onGridInitialized($event)">
    <dxo-header-filter [visible]="true"> </dxo-header-filter>
    <dxo-filter-row [visible]="true"> </dxo-filter-row>
    <dxo-paging [pageSize]="25"> </dxo-paging>
    <dxo-pager [showPageSizeSelector]="true"
               [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-pager>
    <dxo-group-panel [visible]="true"> </dxo-group-panel>
    <dxo-grouping [autoExpandAll]="true"> </dxo-grouping>
    <dxo-column-chooser [enabled]="false"> </dxo-column-chooser>

    <!-- Columns -->
    <dxi-column caption="Id"
                dataField="organisation.organisationId"
                dataType="number"
                [allowHeaderFiltering]="false"> </dxi-column>

    <dxi-column caption="Name"
                dataField="organisation.name"
                dataType="string"
                sortOrder="asc"
                cellTemplate="nameCellTemplate"
                [allowHeaderFiltering]="false"> </dxi-column>

    <dxi-column caption="Coach"
                [allowFiltering]="true"
                [allowHeaderFiltering]="false"
                dataField="coach"
                dataType="string"
                cellTemplate="coachCellTemplate"
                [calculateCellValue]="calculateCoachCellValue"> </dxi-column>

    <dxi-column caption="Lumia"
                dataField="organisation.urlIdentifier"
                dataType="string"
                [allowHeaderFiltering]="false"
                cellTemplate="lumiaUrlCellTemplate"> </dxi-column>

    <dxi-column caption="Status"
                dataField="account.status"
                dataType="integer"
                [groupIndex]="0"> </dxi-column>

    <dxi-column caption="Sub status"
                dataField="account.subStatus"
                dataType="integer"
                [visible]="false"> </dxi-column>

    <dxi-column caption="Type"
                dataField="account.organisationType"
                dataType="string"
                [filterValues]="['Standard']"> </dxi-column>

    <dxi-column caption="Pricing model"
                dataField="account.pricingModel"
                dataType="string"
                [calculateCellValue]="calculatePricingModelCellValue"> </dxi-column>

    <dxi-column caption="Subscription commenced"
                dataField="account.subscriptionCommencedDate"
                dataType="date"
                [format]="dateFormat"
                [allowSorting]="true"
                [visible]="false"> </dxi-column>

    <dxi-column caption="Next charge date"
                dataField="account.nextSubscriptionInvoiceDate"
                dataType="date"
                [format]="dateFormat"
                [allowSorting]="true"
                [visible]="false"> </dxi-column>

    <dxi-column caption="Monthly fee"
                dataField="account.extensions.monthlySubscriptionCost"
                dataType="number"
                [allowSorting]="true"
                [visible]="false"
                [format]="{ type: 'currency' }"> </dxi-column>

    <dxi-column caption="Active users"
                dataField="account.extensions.totalActiveUsers"
                dataType="number"
                [allowSorting]="true"
                [visible]="false"> </dxi-column>

    <dxi-column caption="Annual fee"
                dataField="account.extensions.annualSubscriptionCost"
                dataType="number"
                [allowSorting]="true"
                [visible]="false"
                [format]="{ type: 'currency' }"> </dxi-column>

    <dxi-column caption="Billing period"
                dataField="account.billingPeriod"
                dataType="number"
                [allowSorting]="true"
                [visible]="false"> </dxi-column>

    <dxi-column caption="Payment method"
                dataField="account.paymentMethod"
                dataType="string"
                [allowSorting]="true"
                [visible]="false"> </dxi-column>

    <dxi-column caption="Referrer"
                dataField="referrer"
                dataType="string"
                groupCellTemplate="referrerGroupCellTemplate"
                [visible]="true"> </dxi-column>

    <dxi-column caption="Organisation details"
                dataField="organisation.organisationDetails.value"
                dataType="string"
                cellTemplate="richTextTemplate"
                [calculateCellValue]="calculateOrganisationDetailCellValue"
                [visible]="false"> </dxi-column>

    <dxi-column caption="Partner"
                dataField="account.partner"
                dataType="string"
                [calculateCellValue]="calculatePartnerCellValue"
                [visible]="false"> </dxi-column>

    <dxi-column caption="Key contact"
                dataField="account.keyContactPersonId"
                dataType="string"
                cellTemplate="personCellTemplate"
                [allowHeaderFiltering]="false"
                [calculateCellValue]="calculateKeyContactCellValue"
                [visible]="false"> </dxi-column>

    <!-- Templates -->
    <div *dxTemplate="let item of 'nameCellTemplate'">
        <adapt-link-organisation [organisation]="item.data.organisation"> </adapt-link-organisation>
    </div>
    <div *dxTemplate="let item of 'coachCellTemplate'">
        @for (coach of item.data.coaches; track coach) {
            <div>
                <adapt-link-coach [coach]="coach"></adapt-link-coach>
            </div>
        }
    </div>
    <div *dxTemplate="let item of 'personCellTemplate'">
        <adapt-link-person [personId]="item.data.account.keyContactPersonId"></adapt-link-person>
    </div>
    <div *dxTemplate="let item of 'lumiaUrlCellTemplate'">
        <a target="_blank"
           [href]="getLumiaLinkForOrganisation(item.data.organisation)">{{ item.value }}</a>
    </div>
    <div *dxTemplate="let data of 'richTextTemplate'">
        <div [froalaView]="data.value"></div>
    </div>
    <div *dxTemplate="let item of 'referrerGroupCellTemplate'">Referrer: {{ item.value ?? "None" }}</div>
</dx-data-grid>
